<template>
  <b-modal size="lg" hide-footer no-close-on-esc no-close-on-backdrop :visible="visible" @hidden="$emit('close')">
    <div class="iq-card mb-0" style="min-width: 300px;">
      <div class="iq-card-header d-flex justify-content-between">
        <div class="iq-header-title">
          <h4 class="card-title">{{ formTitle }}</h4>
        </div>
      </div>
      <div class="iq-card-body">
        <div class="row mb-3">
          <div role="group" class="form-group col-md-6">
            <label for="bklgMassId" class="d-block form-label text-left">Select Asset</label>
            <b-form-select class="form-control" id="bklgMassId" placeholder="-- Select Asset --"
              v-model="formData.bklgMassId" :options="assetOptions" />
            <b-form-invalid-feedback v-if="formErrors?.bklgMassId?.required" force-show>
              {{ formErrors?.bklgMassId?.required }}
            </b-form-invalid-feedback>
          </div>

          <div role="group" class="form-group col-md-6">
            <label for="bklgMbloId" class="d-block form-label text-left">Location</label>
            <b-form-select class="form-control" id="bklgMbloId" placeholder="Select Bunker Location"
              v-model="formData.bklgMbloId" :options="bunkerLocations" />
            <b-form-invalid-feedback v-if="formErrors?.bklgMbloId?.required" force-show>
              {{ formErrors?.bklgMbloId?.required }}
            </b-form-invalid-feedback>
          </div>

          <div role="group" class="form-group col-md-6">
            <label for="bklgStartDatetime" class="d-block form-label text-left">Start Bunker</label>
            <date-time-picker v-model="formData.bklgStartDatetime" masks="DD/MM/YYYY, HH:mm" />
            <b-form-invalid-feedback v-if="formErrors?.bklgStartDatetime?.same" force-show>
              {{ formErrors?.bklgStartDatetime?.same }}
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="formErrors?.bklgStartDatetime?.before" force-show>
              {{ formErrors?.bklgStartDatetime?.before }}
            </b-form-invalid-feedback>
          </div>

          <div role="group" class="form-group col-md-6">
            <label for="bklgEndDatetime" class="d-block form-label text-left">End Bunker</label>
            <date-time-picker v-model="formData.bklgEndDatetime" masks="DD/MM/YYYY, HH:mm" />
            <b-form-invalid-feedback v-if="formErrors?.bklgEndDatetime?.same" force-show>
              {{ formErrors?.bklgEndDatetime?.same }}
            </b-form-invalid-feedback>
          </div>

          <div role="group" class="form-group col-md-6">
            <label for="bklgMftyId" class="d-block form-label text-left">Fuel Type</label>
            <b-form-select class="form-control" id="bklgMftyId" v-model="formData.bklgMftyId" :options="fuelTypes" />
            <b-form-invalid-feedback v-if="formErrors?.bklgMftyId?.required" force-show>
              {{ formErrors?.bklgMftyId?.required }}
            </b-form-invalid-feedback>
          </div>

          <div role="group" class="form-group col-md-6">
            <label for="bklgTargetBunker" class="d-block form-label text-left">Target Bunker (L)</label>
            <NumberInput class="form-control" id="bklgTargetBunker" placeholder="Example: 150000"
              v-model="formData.bklgTargetBunker" />
            <b-form-invalid-feedback v-if="formErrors?.bklgTargetBunker?.required" force-show>
              {{ formErrors?.bklgTargetBunker?.required }}
            </b-form-invalid-feedback>
          </div>

          <div role="group" class="form-group col-md-6">
            <label for="bklgType" class="d-block form-label text-left">Type</label>
            <b-form-select class="form-control" id="bklgType" v-model="formData.bklgType"
              :options="[{ value: 'IN', text: 'IN' }, { value: 'OUT', text: 'OUT' }]" />
            <b-form-invalid-feedback v-if="formErrors?.bklgType?.required" force-show>
              {{ formErrors?.bklgType?.required }}
            </b-form-invalid-feedback>
          </div>

          <div class="col-md-12"><hr></div>

          <div role="group" class="form-group col-md-6">
            <label for="bklgStartSounding" class="d-block form-label text-left">Start Sounding
              (L)</label>
            <NumberInput class="form-control" id="bklgStartSounding" placeholder="Start Sounding in Liters"
              v-model="formData.bklgStartSounding" />
            <b-form-invalid-feedback v-if="formErrors?.bklgStartSounding?.required" force-show>
              {{ formErrors?.bklgStartSounding?.required }}
            </b-form-invalid-feedback>
          </div>

          <div role="group" class="form-group col-md-6">
            <label for="bklgEndSounding" class="d-block form-label text-left">End Sounding (L)</label>
            <NumberInput class="form-control" id="bklgEndSounding" placeholder="End Sounding in Liters"
              v-model="formData.bklgEndSounding" />
            <b-form-invalid-feedback v-if="formErrors?.bklgEndSounding?.required" force-show>
              {{ formErrors?.bklgEndSounding?.required }}
            </b-form-invalid-feedback>
          </div>

          <div role="group" class="form-group col-md-12">
            <label for="bklgNote" class="d-block form-label text-left">note (Optional)</label>
            <b-form-textarea id="bklgNote" v-model="formData.bklgNote"
              placeholder="Example: Supplier Pertamina, No DO: 12345" rows="3"></b-form-textarea>
          </div>
        </div>

        <div class="form-group text-right">
          <b-button @click="onCancel" class="mr-1" size="sm" :disabled="isSubmit" variant="outline-secondary">
            <div class="mx-2">Cancel</div>
          </b-button>
          <b-button type="submit" @click="onSubmitClicked" :disabled="isSubmit" variant="primary" size="sm"
            class="ml-1">
            <div class="mx-2">
              <i v-if="isSubmit" class="ri-loader-line"></i>
              Save
            </div>
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import moment from 'moment';
import DateTimePicker from '@/components/directives/DateTimePicker.vue';
import NumberInput from '@/components/directives/NumberInput.vue';

export default {
  name: 'BunkeringLogForm',
  components: { DateTimePicker, NumberInput },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isSubmit: {
      type: Boolean,
      default: false,
    },
    initialData: {
      type: Object,
      default: () => ({}),
    },
    assets: {
      type: Array,
      default: () => [],
    },
    fuelTypes: {
      type: Array,
      default: () => [],
    },
    bunkerLocations: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formData: {},
      formErrors: {},
    };
  },
  computed: {
    formTitle() {
      return this.formData.bklgId ? 'Edit Bunkering Log' : 'New Bunkering Log';
    },
    assetOptions() {
      return this.assets.map((asset) => ({ value: asset.massId, text: asset.massName }));
    },
  },
  methods: {
    initializeFormData() {
      const currentOffset = moment().utcOffset();
      if (this.initialData && this.initialData.bklgId) { // Edit Mode
        this.formData = {
          ...this.initialData,
          bklgStartDatetime: moment(this.initialData?.bklgStartDatetime).add(currentOffset, 'minutes').toDate(),
          bklgEndDatetime: moment(this.initialData?.bklgEndDatetime).add(currentOffset, 'minutes').toDate(),
        };
      } else { // Add Mode
        const bklgMftyId = this.fuelTypes.find((val) => val.text.includes('HSD'))?.value;
        this.formData = {
          bklgStartDatetime: moment().toDate(),
          bklgEndDatetime: moment().add(1, 'hours').toDate(),
          bklgStartSounding: 0,
          bklgEndSounding: 0,
          bklgTargetBunker: null,
          bklgMftyId,
          bklgType: 'IN',
          bklgMbloId: '',
          bklgNote: '',
        };
      }
    },
    validateFields() {
      const startDate = moment(this.formData.bklgStartDatetime);
      const endDate = moment(this.formData.bklgEndDatetime);

      this.formErrors = {
        bklgStartDatetime: {},
        bklgEndDatetime: {},
        bklgStartSounding: {},
        bklgEndSounding: {},
        bklgTargetBunker: {},
        bklgMassId: {},
        bklgMftyId: {},
        bklgMbloId: {},
        bklgType: {},
      };

      if (startDate.isSame(endDate)) this.formErrors.bklgStartDatetime.same = 'Start and end time must not be the same.';
      if (endDate.isBefore(startDate)) this.formErrors.bklgEndDatetime.before = 'End time must not be before start time.';

      // NumberInput ngirim Number, jadi 0 itu falsy — cek kosong eksplisit.
      const targetBunker = this.formData.bklgTargetBunker;
      if (targetBunker === null || targetBunker === undefined || targetBunker === '') {
        this.formErrors.bklgTargetBunker.required = 'Target bunker must be filled.';
      }
      if (!this.formData.bklgMassId) this.formErrors.bklgMassId.required = 'Asset must be selected.';
      if (!this.formData.bklgMftyId) this.formErrors.bklgMftyId.required = 'Fuel type must be selected.';
      if (!this.formData.bklgMbloId) this.formErrors.bklgMbloId.required = 'Location must be filled.';
      if (!this.formData.bklgType) this.formErrors.bklgType.required = 'Type must be selected.';

      return !Object.values(this.formErrors).some((field) => Object.keys(field).length);
    },
    onSubmitClicked() {
      if (!this.validateFields()) {
        this.$toast.error('Please fix the errors in the form.');
        return;
      }

      const payload = {
        bklgId: this.formData.bklgId,
        bklgMassId: this.formData.bklgMassId,
        bklgMbloId: this.formData.bklgMbloId,
        bklgMftyId: this.formData.bklgMftyId,
        bklgStartDatetime: moment(this.formData.bklgStartDatetime).utc().format('YYYY-MM-DD HH:mm:00'),
        bklgEndDatetime: moment(this.formData.bklgEndDatetime).utc().format('YYYY-MM-DD HH:mm:00'),
        bklgTargetBunker: this.formData.bklgTargetBunker,
        bklgType: this.formData.bklgType,
        bklgStartSounding: this.formData.bklgStartSounding,
        bklgEndSounding: this.formData.bklgEndSounding,
        bklgNote: this.formData.bklgNote,
      };
      this.$emit('submit', payload);
    },
    onCancel() {
      this.$emit('close');
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.initializeFormData();
        this.formErrors = {};
      }
    },
  },
  mounted() {
    console.log('Mounted... ', this.initialData);
    console.log('fuel types:', JSON.stringify(this.fuelTypes));
    console.log('assets:', JSON.stringify(this.assets));
    console.log('bunker locations:', JSON.stringify(this.bunkerLocations));
  },
};
</script>
